import { useContext } from "react"
import { config } from "../../context/config"
import { action } from "../../context/action";

export default function Logout () {
    const { api } = useContext(config);
    const { setErrorMessage } = useContext(action);
    const Logout = async () => {
        await fetch(`${api}/user/logout`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type":"application/json",
            }
        }).then((response) => response.json())
        .then((result) => {
            if(result.status) {
                window.location.reload();
                return;
            }
            setErrorMessage(result.message);
        })
    }
    return (
        <div className="btn">
            <button onClick={() => Logout()} className="error-bg">تسجيل الخروج من الحساب</button>
        </div>
    )
}